// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.ui-datepicker .ui-state-default {\n  border: 1px solid #ffffff !important;\n  background: #ffffff !important;\n  font-weight: normal;\n  color: #454545;\n  text-align: center !important;\n}\n.ui-datepicker .ui-state-active {\n  background: #007fff !important;\n}\n.ui-datepicker .ui-datepicker-title {\n    margin: 0 2.3em;\n    line-height: 1.8em;\n    text-align: center;\n    font-size: 12.6px;\n}\n", ""]);
// Exports
module.exports = exports;
